import React from 'react'
import classNames from 'classnames'

type CallButtonProps = {
  next?: boolean
  save?: boolean
  stop?: boolean
  reject?: boolean
  pause?: boolean
  disabled?: boolean
  onClick?: () => void
  type?: 'button' | 'submit' | 'reset'
}

const CallButton: React.FC<CallButtonProps> = ({
  reject,
  next,
  save,
  stop,
  pause,
  disabled,
  onClick,
  type,
}) => {
  return (
    <button
      onClick={() => onClick && onClick()}
      disabled={disabled}
      className={classNames('callButton', {
        'is-save': save,
        'is-reject': reject,
        'is-next': next,
        'is-stop': stop,
        'is-pause': pause,
      })}
      type={type}
    >
      {!save && !next && !stop && !pause && <span className="fa fa-phone" />}
      {next && <span className="fa fa-step-forward" />}
      {pause && <span className="fa fa-pause" />}
      {stop && <span className="fa fa-square" />}
      {save && <span className="fa fa-check" />}
    </button>
  )
}

export default CallButton
